// Share link for a class, the same shape as an assessment's copied URL (AssessmentPage.js handleCopyurl): it goes
// through /login, so a visitor who is not signed in logs in first and is then sent to /student-classes?class=<id>,
// where StudentClasses opens that class. Signed-in students are redirected straight there.
export const normalizeClassCode = (value) => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  return /^c/i.test(raw) ? raw.toUpperCase() : `C${raw}`;
};

export function buildClassShareUrl(classCode) {
  const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  const configuredBaseUrl = process.env.REACT_APP_URL || currentOrigin;
  let baseUrl = currentOrigin.replace(/\/+$/, '');
  try {
    const parsed = new URL(configuredBaseUrl, currentOrigin || 'http://localhost');
    parsed.pathname = String(parsed.pathname || '').replace(/\/api\/method\/?$/, '').replace(/\/+$/, '');
    parsed.search = '';
    parsed.hash = '';
    baseUrl = parsed.toString().replace(/\/+$/, '');
  } catch (error) { /* keep the currentOrigin fallback */ }
  return `${baseUrl}/login/#/student-classes?class=${encodeURIComponent(normalizeClassCode(classCode))}`;
}

// Where a teacher who opens a student share link (/student-classes?class=C0229) should land: that class's own page under
// Teacher > Classes (/classes/C0229), not the teacher home page. '' when `target` is not a class share link.
export function teacherClassPathFromShareTarget(target) {
  const match = /^\/student-classes\?(.*)$/.exec(String(target || '').trim());
  if (!match) return '';
  const code = normalizeClassCode(new URLSearchParams(match[1]).get('class'));
  return code ? `/classes/${encodeURIComponent(code)}` : '';
}
